"use client";
import { onSendWA } from "@/core/helpers/onSendWA";
import React from "react";

const ButtonHubungi = () => {
  return (
    <button onClick={onSendWA} type="button" className="btn btn-primary">
      Hubungi
    </button>
  );
};

export default ButtonHubungi;
